import { effect, inject, Injectable, signal, untracked } from "@angular/core"
import { doc, Firestore, onSnapshot, setDoc } from "@angular/fire/firestore"
import { TourDoc, TourItem } from "./tour.model"
import { debounceSignal } from "@ddtmm/angular-signal-generators"

@Injectable({
  providedIn: "root",
})
export class TourService {
  private firestore = inject(Firestore)

  private _showTour = signal<boolean>(false)
  showTour = this._showTour.asReadonly()
  private _showTourEditor = signal<boolean>(false)
  showTourEditor = this._showTourEditor.asReadonly()
  private _currentItemIndex = signal<number>(0)
  currentItemIndex = this._currentItemIndex.asReadonly()
  private _currentSegmentIndex = signal<number>(0)
  currentSegmentIndex = this._currentSegmentIndex.asReadonly()
  private _currentItemTime = signal<number>(0)
  currentItemTime = this._currentItemTime.asReadonly()

  private _tourLoaded = signal<boolean>(false)
  tourLoaded = this._tourLoaded.asReadonly()
  private tourDocs = signal<TourDoc[]>([])
  _tourItems = signal<TourItem[]>([])
  tourItems = this._tourItems.asReadonly()
  tourItems_map = signal<Map<number, TourItem>>(new Map())
  tourItemsQueue = debounceSignal<TourItem[]>([], 3000)

  constructor() {
    this.subscribeToTourDoc()
    // this.initializeDatabase()
    effect(() => {
      const tourItems_array = this.tourItemsQueue()
      if (tourItems_array.length) {
        untracked(() => this.saveTourItems(tourItems_array))
      }
    })
  }

  setShowTour(showTour: boolean) {
    this._showTour.set(showTour)
  }

  setShowTourEditor(showTourEditor: boolean) {
    this._showTourEditor.set(showTourEditor)
  }

  setCurrentItemIndex(index: number) {
    this._currentItemIndex.set(index)
  }

  setCurrentItemTime(time: number) {
    this._currentItemTime.set(time)
  }

  setCurrentSegmentIndex(index: number) {
    this._currentSegmentIndex.set(index)
  }

  subscribeToTourDoc() {
    return onSnapshot(doc(this.firestore, "content-groups/tour"),
      (snapshot) => {
        const tourDoc = snapshot.data() as TourDoc
        this.tourDocs.set(tourDoc && [tourDoc] || [])
        if (tourDoc) {
          this._tourItems.set(tourDoc.items)
          this.tourItems_map.set(new Map(
            tourDoc.items.map((item, index) => [index, item]),
          ))
        }
        this._tourLoaded.set(!!tourDoc)
      })
  }

  saveTourItems(items: TourItem[]) {
    setDoc(
      doc(this.firestore, "content-groups/tour"),
      { items },
      { merge: false },
    )
  }

  private _scrollToElementName = signal<string | false>("")
  scrollToElementName = this._scrollToElementName.asReadonly()

  scrollToElement(elementName: string | false) {
    this._scrollToElementName.set(elementName)
  }

}
